// extracted by mini-css-extract-plugin
module.exports = {"langMenuWrap":"+gaNF","langTitle":"_5-xZx","innerDropDown":"O8sYJ","isOpen":"EBZrM","langGroup":"_9k+Pk","langItem":"jwlkT","langItemBtn":"Dk1rI"};